import { Component } from 'react';
import classnames from 'classnames';
import classNames from 'classnames/bind';
import Button from 'components/atoms/button/index.jsx';

import styles from './styles.scss';

let cx = classNames.bind(styles);

export default class CalendarMonthNavigation extends Component {
  render() {
    let currentMonth = this.props.currentMonth;
    let navigable = this.props.navigable;

    let className = cx({
      calendarMonthNavigation: true,
    });

    return (
      <div className={classnames(className)}>
        {navigable == true && (
          <div className="nav">
            <Button
              buttonText="Anterior"
              type="prev"
              onClick={this.props.prev}
              className="prevMonth"
            />
            <Button
              buttonText="Siguiente"
              type="next"
              onClick={this.props.next}
              className="nextMonth"
            />
          </div>
        )}
        <div className="currentMonth">{currentMonth}</div>
      </div>
    );
  }
}
